export enum Role {
  admin = 'admin',
  reviewer = 'reviewer',
  pageContentPublisher = 'page_content_publisher',
  assetContentPublisher = 'asset_content_publisher'
}
